import type { AppRouter } from '@repo/types'
import { createTRPCReact } from '@trpc/react-query'

export const trpc = createTRPCReact<AppRouter>()

// Factory function for creating tRPC client (for testing and flexibility)
export function createTRPCClient() {
  return createTRPCReact<AppRouter>()
}
